import API from "./api"

export const getPlayers = (matchId) => {
  return API.get(`/players/${matchId}`)}